import React, { createContext, useContext } from 'react';
import { node, shape, string } from 'prop-types';
const Context = /*#__PURE__*/createContext();

const LuContentContext = _ref => {
  let {
    children
  } = _ref,
      values = Object.assign({}, _ref.value);
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: Object.assign({}, values)
  }, children);
};

export const useLuContentContext = () => useContext(Context);
process.env.NODE_ENV !== "production" ? LuContentContext.propTypes = {
  children: node,
  value: shape({
    links: shape({
      blog: string,
      facebook: string,
      twitter: string,
      instagram: string,
      pinterest: string
    })
  })
} : void 0;
export default LuContentContext;